var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"proceed-btn",class:{ disabled: !_vm.isProceedEnable || _vm.isLoading, loading: _vm.isLoading }},[_vm._v(" "+_vm._s(_vm.isLoading ? '' : 'Proceed')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }